import * as actionTypes from './actionTypes';

export function saveAccessKey(payload: any) {
    return {
        type: actionTypes.SAVE_ACCESS_KEY,
        payload
    }
}

export function saveProductPayload(productPayload: any, stateLocation: string, productSavedLocation: string) {
    return {
        type : actionTypes.SAVE_PRODUCT_PAYLOAD,
        payload : {
        stateLocation,
        productPayload,
        productSavedLocation,
        }
    }
}


// WEBPACK FOOTER //
// ./modules/access-key-processor/actions/actions.ts